module.exports = __webpack_public_path__ + "static/NotoSerif-524c974f6803243cd3ed415de6c4f0c4.woff";